import script from "./Show.vue?vue&type=script&setup=true&lang=ts"
export * from "./Show.vue?vue&type=script&setup=true&lang=ts"

import "./Show.vue?vue&type=style&index=0&id=20596d4d&lang=postcss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20596d4d"]])

export default __exports__